import React from 'react';

/** Renderiza texto do guia: parágrafos e linhas com "- " viram lista. */
export function renderGuideContent(text: string): React.ReactNode {
    const blocks = text.split(/\n\n+/).filter((b) => b.trim());
    if (blocks.length === 0) return null;

    return blocks.map((block, bi) => {
        const lines = block.split('\n').map((l) => l.trim()).filter(Boolean);
        const bullets = lines.filter((l) => l.startsWith('- '));
        const paragraphs = lines.filter((l) => !l.startsWith('- '));

        return (
            <React.Fragment key={bi}>
                {paragraphs.map((p, i) => (
                    <p key={`p-${bi}-${i}`}>{p}</p>
                ))}
                {bullets.length > 0 && (
                    <ul>
                        {bullets.map((b, i) => (
                            <li key={`b-${bi}-${i}`}>{b.replace(/^-\s*/, '')}</li>
                        ))}
                    </ul>
                )}
            </React.Fragment>
        );
    });
}
